import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import modules from "./modules";

Vue.use(Vuex);

// eslint-disable-next-line no-unused-vars

export default new Vuex.Store({
  modules: {},
  state: { ...modules.state },
  getters: { ...modules.getters },
  mutations: { ...modules.mutations },
  actions: { ...modules.actions },
  plugins: [
    createPersistedState({
      paths: ["selectedPrinters", "qrExpiryTime", "language", "selectedDrawer"]
    })
  ]
});
